<div class="flex h-3/4 items-center justify-center">
  <div
    class="h-30 flex flex-col items-center justify-center space-y-20 rounded-3xl bg-white p-36 shadow-lg"
  >
    <div class="flex items-center justify-center space-x-4"> <img ngSrc="assets/media/enac-logo.png" width="50" height="50" alt="Salesforce" />
      <h1 class="text-center text-2xl">{{ 'TITLE' | translate }}</h1>
    </div>
    <div class="grid grid-cols-2 gap-4">
      <button
        mat-flat-button
        class="min-h-10! custom-button"
        (click)="signIn()"
        [attr.aria-label]="'AUTHENTICATION.ACTIONS.LOGIN_1' | translate"
      >
      <span>
        {{ 'AUTHENTICATION.ACTIONS.LOGIN_1' | translate }}
      </span>
      </button>
      <button
        mat-flat-button
        class="min-h-10! custom-button"
        (click)="signInWithSpid()"
        [attr.aria-label]="'AUTHENTICATION.ACTIONS.LOGIN_2' | translate"
      >
      <span>
        {{ 'AUTHENTICATION.ACTIONS.LOGIN_2' | translate }}
      </span>
      </button>
    </div>
  </div>
</div>
